import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import "./support.css";

const Root = () => {
  // useEffect(() => {
  //   // Check if cache has been cleared in this session
  //   const isFirstLoad = !sessionStorage.getItem("cacheCleared");

  //   if (isFirstLoad) {
  //     // Clear browser cache using the caches API
  //     if ("caches" in window) {
  //       caches.keys().then((cacheNames) => {
  //         cacheNames.forEach((cacheName) => caches.delete(cacheName));
  //       });
  //     }

  //     // Clear local storage
  //     localStorage.clear();

  //     // Set a flag to indicate that cache has been cleared for this session
  //     sessionStorage.setItem("cacheCleared", "true");

  //     // Reload with a unique query string to bypass the cache
  //     // window.location.href =
  //     //   window.location.href.split("?")[0] +
  //     //   "?clearCache=" +
  //     //   new Date().getTime();
  //   }
  // }, []);

  return (
    <div className="app">
      <App />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// ReactDOM.createRoot(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
